module.exports = __webpack_public_path__ + "static/007221-39014624a895b188fce0d14d28ce431c.jpg";